/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var FxIdDomainStoreEnumsStoreProductType;
(function (FxIdDomainStoreEnumsStoreProductType) {
    FxIdDomainStoreEnumsStoreProductType["None"] = "None";
    FxIdDomainStoreEnumsStoreProductType["Redmin"] = "Redmin";
    FxIdDomainStoreEnumsStoreProductType["Coin"] = "Coin";
    FxIdDomainStoreEnumsStoreProductType["Subscription"] = "Subscription";
    FxIdDomainStoreEnumsStoreProductType["UnknownDefaultOpenApi"] = "11184809";
})(FxIdDomainStoreEnumsStoreProductType || (FxIdDomainStoreEnumsStoreProductType = {}));
export function instanceOfFxIdDomainStoreEnumsStoreProductType(value) {
    for (const key in FxIdDomainStoreEnumsStoreProductType) {
        if (Object.prototype.hasOwnProperty.call(FxIdDomainStoreEnumsStoreProductType, key)) {
            if (FxIdDomainStoreEnumsStoreProductType[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function FxIdDomainStoreEnumsStoreProductTypeFromJSON(json) {
    return FxIdDomainStoreEnumsStoreProductTypeFromJSONTyped(json, false);
}
export function FxIdDomainStoreEnumsStoreProductTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function FxIdDomainStoreEnumsStoreProductTypeToJSON(value) {
    return value;
}
export function FxIdDomainStoreEnumsStoreProductTypeToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=FxIdDomainStoreEnumsStoreProductType.js.map